import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
  moduleId: module.id,
  selector: "child-cell",
  template: `<div
    (click)="invokeParentMethod()"
    placement="bottom"
    ngbPopover="sdfasdfasdfasdf"
    popoverTitle="Popover on bottom"
  >
    {{ messages["actions"] }}<i class="fa fa-arrow-circle-down"></i>
  </div>`,
  styles: [
    `
      .btn {
        line-height: 0.5;
      }
    `,
  ],
})
export class HistoryActionComponent implements ICellRendererAngularComp {
  public params: any;
  messages: any;

  agInit(params: any): void {
    this.messages = JSON.parse(localStorage.getItem("messages"));
    this.params = params;
  }

  public invokeParentMethod() {
    //`Row: ${this.params.node.rowIndex}, Col: ${this.params.colDef.headerName}`
    this.params.context.componentParent.methodFromParent(this.params.node.data);
  }

  refresh(): boolean {
    return false;
  }
}



// WEBPACK FOOTER //
// ./src/app/payment/history_action.component.ts